import React from "react";
import "./personalFooter.scss";
import Text from "componets/atoms/text/text";
import "../../../styles/fontSizes.scss";
import imgSrc from "bgImages/personalFooter.JPG";
import { useEffect, useState } from "react";
import axios from "axios";
import { baseURL } from "utilities/variables";
const PersonalFooter = ({ textSize, tabsData }) => {
  const [section1, setSection1] = useState(undefined);
  const [section2, setSection2] = useState(undefined);

  const [data, setData] = useState([section1, section2]);
  useEffect(() => {
    let auxData = [section1, section2];

    setData(auxData);
  }, [section1, section2]);
  useEffect(() => {
    axios.get(baseURL + "/api/footer-contenido?populate=*").then((response) => {
      let auxData = response.data.data;
      let auxEasyData1 = [];
      let auxEasyData2 = [];
      auxData.attributes.secciones1.map((value) => {
        auxEasyData1.push({
          title: value.titulo,
          description: value.subtitulo,
        });
      });
      setSection1(auxEasyData1);

      auxData.attributes.secciones2.map((value) => {
        auxEasyData2.push({
          title: value.titulo,
          description: value.subtitulo,
        });
      });
      setSection2(auxEasyData2);
    });
  }, []);
  return (
    <>
      <div
        style={{ fontSize: textSize ? textSize : 1 }}
        className="personal-footer__container"
      >
        <>
          {!data[0] ? (
            <p>Un momento, mientras la información se carga</p>
          ) : (
            <>
              <>
                {!data[1] ? (
                  <p>Un momento, mientras la información se carga</p>
                ) : (
                  <>
                    <Text
                      className={"personal-footer__title"}
                      textSize={3}
                      type="h"
                    >
                      Datos de contacto
                    </Text>
                    <div className="personal-footer__data">
                      <div className="personal-footer__column">
                        {data[0].map((data, index) => (
                          <div key={index}>
                            <Text textSize={textSize} type="h">
                              {data.title}
                            </Text>
                            <Text textSize={textSize} type="p">
                              {data.description}
                            </Text>
                          </div>
                        ))}
                      </div>
                      <div className="personal-footer__column">
                        {data[1].map((data, index) => (
                          <div key={index}>
                            <Text textSize={textSize} type="h">
                              {data.title}
                            </Text>
                            <Text textSize={textSize} type="p">
                              {data.description}
                            </Text>
                          </div>
                        ))}
                      </div>
                    </div>
                    <img
                      className="personal-footer__image"
                      src={imgSrc}
                      alt="panorámica de la Sede La Paz"
                    />
                  </>
                )}
              </>
            </>
          )}
        </>
      </div>
    </>
  );
};

export default PersonalFooter;
